import React from "react";
import TransactionListASAP from "./TransactionListASAP"

export default class Receipt extends React.Component {

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        localStorage.setItem('TransactionType', JSON.stringify(3));
    }

    render() {
        return (
            <div>
                <TransactionListASAP type={3} history={this.props.history} delivery={false}></TransactionListASAP>
            </div>
        );
    }
}